import { Component, OnInit, Inject, PLATFORM_ID, NgZone } from '@angular/core';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { Observable } from 'rxjs';
import { NotificationsService } from './core/services/notifications.service';
import { Notification } from './core/models/notification';
import { take } from 'rxjs/operators';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { AuthService } from './auth/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  title = 'app';
  loading = true;
  $notifications: Observable<Notification[]>;

  auth: any;

  constructor(
    @Inject(DOCUMENT) private document: any,
    @Inject(PLATFORM_ID) private platformId,
    private router: Router,
    private matIconRegistry: MatIconRegistry,
    private notificationService: NotificationsService,
    private afm: AngularFireMessaging,
    private ngZone: NgZone,
    private authService: AuthService
  ) {
    const that = this;
    matIconRegistry.setDefaultFontSetClass('material-icons-outlined');
    this.auth = this.authService.getAuth().subscribe(a => {
      this.auth = a;

      if (a.auth) {
        this.$notifications = notificationService.get();
      }
    });
  }

  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (isPlatformBrowser(this.platformId) && event instanceof NavigationEnd) {
        // setTimeout(() => {
        this.loading = false;
        // }, 500);
      }

      if (isPlatformBrowser(this.platformId) && event instanceof NavigationStart) {
        this.loading = true;
      }

      if (isPlatformBrowser(this.platformId) && event instanceof NavigationEnd) {
        if ((<any>window).gtag) {
          (<any>window).gtag('config', 'G-C4SLWGZEBL', { page_path: event.urlAfterRedirects, anonymize_ip: true });
        }
      }
    });

    if (isPlatformBrowser(this.platformId)) {
      this.document.querySelector('body').classList.add('set--in');

      setTimeout(() => {
        this.loading = false;
      }, 1000);
    } else {
      this.loading = false;
    }

    if (this.auth.auth) {
      this.afm.messages.subscribe((a: any) => {
        const bundle = JSON.parse(a.data['gcm.notification.data']).bundle;
        this.$notifications = this.notificationService.get();
        const n = new Notification(a.notification.title, { body: a.notification.body, icon: a.notification.icon });

        n.onclick = e => {
          console.log('Click', e);
        };
      });
    }
  }

  async markNotificationAsRead(notification: Notification) {
    if (notification.IsRead) {
      return;
    }

    if (notification.AnnouncementId) {
      this.$notifications = this.notificationService.MarkAnnouncementAsRead(notification).pipe(take(1));
    } else if (notification.SubscriptionId) {
      this.$notifications = this.notificationService.markAsRead(notification).pipe(take(1));
    }
  }
}
